import novel from "./novel";
import scienceFiction from "./scienceFiction";
import screenplay from "./screenplay";
// import stageplay from "./stageplay";

export default [
  {
    id: "novel",
    label: "Novel",
    icon: "fiction",
    template: novel,
    category: "fiction",
    creator: "Timeline.App",
    description:
      "A template for Fiction writing, containing events, scenes, characters, locations, themes and story arcs"
  },
  {
    id: "screenplay",
    label: "Screenplay",
    icon: "screenplay",
    template: screenplay,
    category: "fiction",
    creator: "Timeline.App",
    description:
      "A template for Fiction writing, containing events, scenes, characters, locations, themes and story arcs"
  },
  {
    id: "scienceFiction",
    label: "Science Fiction",
    icon: "solarSystem",
    template: scienceFiction,
    category: "fiction",
    creator: "Timeline.App",
    description:
      "A template for Fiction writing, containing events, scenes, characters, locations, themes and story arcs"
  }
  // {
  //   id: "stageplay",
  //   label: "Stage Play",
  //   icon: "historical",
  //   template: stageplay
  // },
];
